function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_13_43)",
  fill: "#7E86A0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.783 15H8.75a.625.625 0 110-1.25h3.935l-.904-.775a.625.625 0 01.813-.95l2.188 1.875a.625.625 0 01.018.933l-2.187 2.031a.625.625 0 11-.85-.916l1.02-.948z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.625 3.125a2.5 2.5 0 012.5-2.5H12.5a2.5 2.5 0 012.5 2.5V5h1.875a2.5 2.5 0 012.5 2.5v9.375a2.5 2.5 0 01-2.5 2.5H7.5a2.5 2.5 0 01-2.5-2.5V15H3.125a2.5 2.5 0 01-2.5-2.5V3.125zm13.125 0V5H7.5A2.5 2.5 0 005 7.5v6.25H3.125c-.69 0-1.25-.56-1.25-1.25V3.125c0-.69.56-1.25 1.25-1.25H12.5c.69 0 1.25.56 1.25 1.25zM6.25 7.5c0-.69.56-1.25 1.25-1.25h9.375c.69 0 1.25.56 1.25 1.25v9.375c0 .69-.56 1.25-1.25 1.25H7.5c-.69 0-1.25-.56-1.25-1.25V7.5z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13_43"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));